<!-- 3 STEP PROCESS FORM: SETTINGS, SEARCH LISTING, AND LISTING RESULTS -->
<h3 class="text-center width-100" *ngIf="!zeroResults">
  Text Block
  <i
    class="fa fa-times pull-right close-sidenav"
    aria-hidden="true"
    title="Close Text Block"
    (click)="closeNav()"
  ></i>
</h3>
<div class="width-100 text-center" style="margin-bottom: 25px">
  <h3 class="text-center width-100 d-inline" style="margin-right: 10px" *ngIf="zeroResults">
    Zero Results
  </h3>
  <i
    class="range-inputs-tooltip fa fa-question-circle-o d-inline"
    aria-hidden="true"
    [matTooltipPosition]="'right'"
    [matTooltip]="zeroResultsMessage"
    *ngIf="zeroResults"
  >
  </i>
</div>
<div fxLayout="column" fxLayoutAlign="center stretch" style="width: 95%">
  <form #formText="ngForm">
    <medium-editor-shared
      *ngIf="text"
      #medEditorTB
      [innerHTMLText]="text"
      [location]="'edittext'"
    ></medium-editor-shared>
  </form>

  <!-- MORE OPTIONS -->
  <!-- <div class="edit row">
            <div class="col-12">
            <button role="button" aria-label="More Options" class="btn btn-link"
                (click)="isCollapsed = !isCollapsed"
                >More Options
                <i *ngIf="isCollapsed" class="fa fa-caret-right" aria-hidden="true"></i>
                <i *ngIf="!isCollapsed" class="fa fa-caret-down" aria-hidden="true"></i>
            </button>
            </div>
        </div> -->
  <!-- <div class="width-100 padding-0-25" [ngbCollapse]="isCollapsed"> -->
  <div class="width-100 padding-0-25" *ngIf="!zeroResults">
    <div class="block row text-center margin-15-0">
      <h3>
        Design Elements
        <i
          class="fa fa-question-circle-o"
          aria-hidden="true"
          style="margin-left: 5px"
          matTooltip="Change the overall Font and Background Color, flush out margins in template, and add additional classes for this component."
          [matTooltipPosition]="'right'"
        >
        </i>
      </h3>
    </div>
    <div class="edit row">
      <div class="col-12 margin-5-0">
        <div class="form-group">
          <label for="color">Font Color</label><br />
          <input
            type="text"
            class="form-control color"
            id="color"
            aria-describedby="Font Color"
            placeholder="Enter Font Color"
            [(ngModel)]="color"
          />
          <button
            role="button"
            type="button"
            aria-label="Choose Color"
            class="btn btn-circle"
            [style.background]="color"
            [(colorPicker)]="color"
          ></button>
        </div>
      </div>
      <div class="col-12 margin-5-0">
        <div class="form-group">
          <label for="background">Background Color</label><br />
          <input
            type="text"
            class="form-control color"
            id="background"
            aria-describedby="Background"
            placeholder="Enter Background Color"
            [(ngModel)]="background"
          />
          <button
            role="button"
            type="button"
            aria-label="Choose Color"
            class="btn btn-circle"
            [style.background]="background"
            [(colorPicker)]="background"
          ></button>
        </div>
      </div>
      <!-- <div class="col-12 margin-5-0" *ngIf="!zeroResults">
                    <div class="form-group">
                        <label for="className">Additional Classes
                            <i class="fa question-help fa-question-circle-o" aria-hidden="true"
                                matTooltip="Add additional classes through the CSS Editor"
                                [matTooltipPosition]="'after'"
                                ></i>
                        </label>
                        <input type="text" class="form-control"
                                id="className" aria-describedby="Additional Class Names defined through the CSS Editor"
                                placeholder="class names defined from CSS editor"
                                [(ngModel)]="className"
                                >
                    </div>
                </div> -->
      <div class="col-12 margin-5-0 padding-15-0" *ngIf="!zeroResults">
        <div class="form-check">
          <label for="flush" class="form-check-label">
            <input
              style="
                width: 20px;
                height: 20px;
                margin-right: 5px;
                position: relative;
                vertical-align: bottom;
              "
              type="checkbox"
              class="form-check-input"
              id="flush"
              [(ngModel)]="flushed"
            />Flush in template.
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="edit row" *ngIf="!zeroResults">
    <div class="col-12 margin-25-0 text-end">
      <button
        role="button"
        type="button"
        aria-label="Preview"
        class="btn btn-link"
        style="left: initial"
        (click)="updateTEXT(textBlock)"
      >
        Preview
      </button>
      <button
        role="button"
        type="button"
        aria-label="Save and Close"
        class="btn btn-primary"
        style="left: initial"
        (click)="submitTEXT(textBlock)"
      >
        Save and Close
      </button>
    </div>
  </div>
  <div class="edit row" *ngIf="zeroResults">
    <div class="col-12 margin-25-0 text-end">
      <button
        role="button"
        type="button"
        aria-label="Save Changes"
        class="btn btn-primary"
        style="left: initial"
        (click)="submitTEXT4zr()"
      >
        Save Changes
      </button>
    </div>
  </div>
</div>
